import React, { useEffect, useState } from "react";
import { Timer, AlertTriangle, Flag } from "lucide-react";
import { toast } from "sonner";
import { restaurantApi } from "../../lib/api";

// Average delivery time (pickup -> delivered) per driver, with a "flag slow driver" toggle
// that ranks that partner's future orders last for this restaurant.
export default function DriverEtaHistory({ className = "" }) {
  const [d, setD] = useState(null);
  useEffect(() => { restaurantApi.driverEtaHistory().then(setD).catch(() => setD({ drivers: [], overall_avg_min: 0 })); }, []);
  if (!d) return null;

  const toggleFlag = async (row) => {
    const next = !row.flagged;
    setD((p) => ({ ...p, drivers: p.drivers.map((x) => (x.driver_id === row.driver_id ? { ...x, flagged: next } : x)) }));
    try { await restaurantApi.flagDriver(row.driver_id, next); toast.success(next ? `${row.driver_name} flagged — ranked lower on your orders` : `${row.driver_name} unflagged`); }
    catch { setD((p) => ({ ...p, drivers: p.drivers.map((x) => (x.driver_id === row.driver_id ? { ...x, flagged: !next } : x)) })); toast.error("Could not update"); }
  };

  return (
    <div className={`kt-card p-5 ${className}`} data-testid="driver-eta-history">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-semibold text-ink"><Timer className="h-4 w-4 text-brand" /> Delivery speed by driver</h3>
        {d.drivers?.length > 0 && <span className="text-xs text-ink-muted">Avg {d.overall_avg_min} min</span>}
      </div>
      {!d.drivers?.length ? (
        <p className="mt-2 text-sm text-ink-muted">No completed deliveries yet.</p>
      ) : (
        <div className="mt-3 divide-y divide-surface-200">
          {d.drivers.map((r) => (
            <div key={r.driver_id} className="flex items-center justify-between gap-3 py-2 text-sm" data-testid={`eta-driver-${r.driver_id}`}>
              <div className="min-w-0"><p className="truncate font-medium text-ink">{r.driver_name}</p><p className="text-xs text-ink-muted">{r.deliveries} deliveries · {r.fastest_min}–{r.slowest_min} min range</p></div>
              <div className="flex shrink-0 items-center gap-2">
                <span className={`font-semibold ${r.slow ? "text-red-600" : "text-ink"}`}>{r.avg_min} min</span>
                {r.slow && <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-[10px] font-bold text-red-600" data-testid={`eta-slow-${r.driver_id}`}><AlertTriangle className="h-3 w-3" /> Slow</span>}
                <button onClick={() => toggleFlag(r)} className={`inline-flex items-center gap-1 rounded-full border px-2 py-1 text-[11px] font-semibold transition ${r.flagged ? "border-red-200 bg-red-50 text-red-600" : "border-surface-200 text-ink-muted hover:bg-surface-100"}`} data-testid={`eta-flag-${r.driver_id}`} title={r.flagged ? "Unflag" : "Flag as slow — rank lower on your orders"}>
                  <Flag className="h-3 w-3" /> {r.flagged ? "Flagged" : "Flag"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
